// Mock profile aligned with VendorProfileResponseDto (GestioneAccount MS).
export const getMockVendorProfile = () => ({
  nomeCommerciale: "Vendor Test S.r.l.",
  ragioneSociale: "Vendor Test Societa a Responsabilita Limitata",
  codiceFiscale: "VRNTST80A01H501Z",
  partitaIVA: "12345678901",
  codiceSDI: "ABCDEF1",
  indirizzoPec: "pec@vendor.test",
  indirizzoEmail: "referente@vendor.test",
  sitowebAziendale: "https://vendor.test",
  numeroTelefono: "0123456789",
  nomeReferente: "Vendor",
  cognomeReferente: "Test",
  emailPubblica: "info@vendor.test",
  emailReferente: "",
  telefonoReferente: "",
  urlSftp: "",
  utenteSftp: "",
  passwordSftp: "",
  logo: "",
  indirizzoVia: "Via Esempio",
  indirizzoCivico: "1",
  indirizzoCap: "00100",
  indirizzoCitta: "Roma",
  indirizzoProvincia: "Roma",
  indirizzoRegione: "Lazio",
  indirizzoStato: "Italia",
});
